import axios from "axios";
import $day from "dayjs"
const module = {
  namespaced: true,
  state: {
    data: {
      user_miscarriage: '',
    },
  },
  mutations: {
    fetchData: (state, info) => {
      if(info.user_miscarriage) {
        info.user_miscarriage.filter((item) => {
          item.editableFlag = true
          return item
        })
        state.data = info
      } else {
        state.data = []
      }
    },
    addData: (state, info) => {
      info.user_miscarriage.editableFlag = true
      state.data.user_miscarriage.push(info.user_miscarriage)
    },
    updateData: (state, info) => {
      return state.data.user_miscarriage = state.data.user_miscarriage.filter((item) => {
        if (item.id == info.id) {
          item = info
        }
        return item
      })
    },
    removeData: (state, info) => {
      return state.data.user_miscarriage = state.data.user_miscarriage.filter((item) => {
        return item.id != info
      })
    },
  },
  actions: {
    async fetchData ({commit}) {
      const response = await axios.get('user/data/miscarriage')
      commit ('fetchData', response.data)
    },
    async updateData ({commit}, data) {
      data.datetime = $day(data.datetime).format('YYYY-MM-DD HH:mm:ss')
      const response = await axios.put('user/data/miscarriage/'+data.id, data)
      commit ('updateData', response.data)
    },
    async addData ({commit}, data) {
      data.datetime = $day(data.datetime).format('YYYY-MM-DD HH:mm:ss')
      const response = await axios.post('user/data/miscarriage', data)
      commit ('addData', response.data)
    },
    async removeData ({commit}, id) {
      await axios.delete('user/data/miscarriage/'+id).then(() => {
        commit ('removeData', id)
      })
    },
  }
}
export default module
